import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { WampService } from 'src/app/services/wamp.service';
import { BecareConfigService } from 'src/app/services/becare-config.service';

@Component({
  selector: 'app-logoinfo',
  templateUrl: './logoinfo.component.html',
  styleUrls: ['./logoinfo.component.scss']
})
export class LogoinfoComponent implements OnInit {

  serverdatetime: string;
  serverdate: string;
  servertime: string;
  lastHeartbeat: moment.Moment;

  constructor(private wamp: WampService, public becareconfig: BecareConfigService) {
    this.wamp.heartbeatEvent.subscribe(event => {
      console.log('receive heatbeat event');
      console.log(event);
      // Update time
      const serverDate = moment.unix(event.timestamp);
      this.serverdate = serverDate.format('DD/MM/YYYY');
      this.servertime = serverDate.format('HH:mm:ss');
      // Update last timestamp
      this.lastHeartbeat = moment();
    });
  }

  ngOnInit(): void {
  }
}
